<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 p-0 m-b-6'">
    <div class="p-10  selection-tab-filter" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="pr-16 selection-tab" fxFlex.gt-sm="75">
            <mat-tab-group mat-align-tabs="start" [selectedIndex]="sharedService.selectedSelectionTabId - 1"
                (selectedTabChange)="SelectionTabChange($event)">
                <mat-tab *ngFor="let item of sharedService.selectionTabList | listFilter: 'ISPERMIT': true"
                    [label]="item.viewValue">
                    <div fxFlex="100">
                        <app-employee-selection-filters *ngIf="sharedService.selectedSelectionTabId == 1 ">
                        </app-employee-selection-filters>
                        <app-leave-selection-filters *ngIf="sharedService.selectedSelectionTabId == 2">
                        </app-leave-selection-filters>
                        <app-actuation-selection-filter *ngIf="sharedService.selectedSelectionTabId == 3">
                        </app-actuation-selection-filter>
                        <app-task-selection-filters *ngIf="sharedService.selectedSelectionTabId == 5">
                        </app-task-selection-filters>
                    </div>
                </mat-tab>
            </mat-tab-group>

        </div>
        <div class="more-filter-btn">
            <button mat-raised-button class="btn-run m-r-10 m-b-10" (click)="excecuteQueryForSearch()"> Ejecutar
            </button>
            <button mat-raised-button class="mat-accent m-r-10 m-b-10" (click)="openMoreFilterPopup()"> Más
                filtros</button>
            <button mat-raised-button class="mat-accent m-r-10 m-b-10" (click)="selectionService.ShowHideLeavePanel()">
                <span *ngIf="!selectionService.isShowLeavePanel">Ver informe</span>
                <span *ngIf="selectionService.isShowLeavePanel">Ocultar informe</span>
            </button>

            <button *ngIf="selectionService.selectionPermissions.HasWord && sharedService.selectedSelectionTabId == 2"
                mat-raised-button class="mat-accent m-r-10" (click)="ShowLeaveReportPopup()"> Word </button>

            <button *ngIf="selectionService.selectionPermissions.HasExcel" mat-raised-button class="mat-accent m-r-10"
                (click)="generateExcelFile()"> Excel </button>

            <button *ngIf="sharedService.selectedSelectionTabId === 5 && selectionService.dataSource.data.length > 0"
                mat-raised-button class="mat-accent m-r-10" (click)="ShowTaskChangePopup()">Cambiar</button>

            <!-- <mat-icon *ngIf="sharedService.selectedSelectionTabId === 5" class="except cursor-pointer verticle-middle"
                [matMenuTriggerFor]="appMenu">more_vert</mat-icon>

            <mat-menu #appMenu="matMenu" class="except">
                <button class="except" mat-menu-item (click)="OpenTaskTransferPopup(TaskTransferTypes.Doctor)">
                    <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                        group </mat-icon> Derivar tareas médicas
                </button>
                <button class="except" mat-menu-item (click)="OpenTaskTransferPopup(TaskTransferTypes.Administrator)">
                    <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                        transfer_within_a_station </mat-icon> Derivar tareas administrativas
                </button>
                <button class="except" mat-menu-item (click)="OpenTaskTransferPopup(TaskTransferTypes.Date)">
                    <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                        date_range </mat-icon> Cambiar fecha de tareas
                </button>
            </mat-menu> -->
            <button *ngIf="sharedService.selectedSelectionTabId === 3" mat-raised-button
                class="mat-accent m-r-10 m-b-10" (click)="selectionService.toggleRecordingsPanel()">Grabaciones</button>

        </div>
    </div>
</div>